import styled from "styled-components";

export const Container = styled.div`
  background-color: #8884d8;
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  border-radius: 16px;
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 1.5rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;